<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Edit step</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="editStep" @submit.prevent="saveChanges">
          <v-container fluid grid-list-xl class="pt-0">
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.step.inlet"
                    :model="subProductsOrmModel"
                    name="inlet"
                    label="Select inlet products"
                    item-text="name"
                    item-value="id"
                    return-object
                    multiple
                  />
                  <field-messages
                    name="inlet"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Inlet products is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.step.outlet"
                    :model="productsOrmModel"
                    name="outlet"
                    label="Select outlet products"
                    item-text="name"
                    item-value="id"
                    return-object
                    multiple
                  />
                  <field-messages
                    name="outlet"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Outlet products is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.step.selectedParameters"
                    :items="normalizeParameters"
                    name="parameters"
                    label="Select parameters"
                    item-text="name"
                    item-value="name"
                    return-object
                    multiple
                    required
                  />
                  <field-messages
                    name="parameters"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Parameters is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SubProducts from '@/orm/models/Subproducts';
import Products from '@/orm/models/Products';
import asyncAutocomplete from '@/components/form/asyncAutocomplete';

export default {
  name: 'editProcessStageStepPopup',
  props: {
    dialog: Boolean,
    step: Object,
  },
  data() {
    return {
      data: {
        step: JSON.parse(JSON.stringify(this.step)),
      },
      subProductsOrmModel: SubProducts,
      productsOrmModel: Products,
      editStep: {},
    };
  },
  watch: {
    dialog: function(val) {
      if (val) {
        this.data.step = JSON.parse(JSON.stringify(this.step));
      }
    },
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
    normalizeParameters() {
      return this.data.step.parameters
        ? Object.entries(this.data.step.parameters).map(arr => ({
          name: arr[0],
          min: null,
          max: null,
          target: null,
          ...arr[1],
        }))
        : [];
    },
  },
  methods: {
    close() {
      this.editStep._reset();
      this.dialogLocal = false;
    },
    saveChanges() {
      if (!this.editStep.$valid) {
        return;
      }
      this.$emit('update', this.data.step);
      this.close();
    },
  },
  components: {
    asyncAutocomplete,
  },
};
</script>
